import { render, staticRenderFns } from "./ProjectHours.vue?vue&type=template&id=a786e150"
import script from "./ProjectHours.vue?vue&type=script&lang=js"
export * from "./ProjectHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports